import React from "react";
import { Paper } from "@mui/material";
import moment from "moment";

const TaskTooltip = ({
  task,
  isRescheduled,
  reschedTimeFrom,
  reschedTimeTo,
  reschedTotalMins,
  startTime,
  endTime,
  getTotalMinutes,
  rawStart,
  rawEnd,
}) => {
  const formatTime = (dateStr) => {
    return dateStr ? moment(dateStr).format("HH:mm") : "N/A";
  };

  return (
    <Paper
      elevation={6}
      style={{
        position: "absolute",
        marginTop: "8px",
        backgroundColor: "#fff",
        borderRadius: "10px",
        padding: "14px",
        zIndex: 1100,
        fontSize: "12px",
        minWidth: "260px",
        border: "1px solid #ddd",
      }}
    >
      <div style={{ lineHeight: "1.6" }}>
        <div
          style={{
            borderBottom: "1px solid #f0f0f0",
            paddingBottom: "6px",
            marginBottom: "8px",
          }}
        >
          <strong
            style={{ fontSize: "14px", display: "block", color: "#2c3e50" }}
          >
            {task?.client}
          </strong>
          <div style={{ color: "#666", fontSize: "11px" }}>
            📍 {task?.area || "Area Not Set"} | Status:{" "}
            <strong>{task?.status?.replace("_", " ").toUpperCase()}</strong>
          </div>
        </div>
        {isRescheduled && (
          <div
            style={{
              backgroundColor: "#fff5f5",
              padding: "6px",
              borderRadius: "6px",
              marginBottom: "8px",
              border: "1px solid #feb2b2",
            }}
          >
            <strong style={{ color: "#c53030" }}>⚠️ Rescheduled Visit</strong>
            <div style={{ fontSize: "11px" }}>
              <div>
                <strong>New Slot:</strong> {reschedTimeFrom} - {reschedTimeTo}
              </div>
              <div>
                <strong>Total:</strong> {reschedTotalMins} minutes
              </div>
            </div>
          </div>
        )}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "95px 1fr",
            rowGap: "2px",
          }}
        >
          <strong>Contract:</strong>{" "}
          <span>
            {startTime} - {endTime}
          </span>
          <strong>Contract Mins:</strong>{" "}
          <span>{getTotalMinutes(rawStart, rawEnd)}m</span>
          <strong>Visit Type:</strong>{" "}
          <span>{task?.shift_details?.shift_name || "N/A"}</span>
          <strong>Carers Req:</strong> <span>{task.carers_required}</span>
          <strong>Staff Needed:</strong>{" "}
          <span
            style={{
              color:
                task.carers_required - task.employee_assigned > 0
                  ? "#d32f2f"
                  : "#2e7d32",
              fontWeight: "bold",
            }}
          >
            {task.carers_required - task.employee_assigned} More
          </span>
        </div>
        <div
          style={{
            marginTop: "10px",
            paddingTop: "8px",
            borderTop: "1px solid #f0f0f0",
          }}
        >
          <strong>Assigned Staff:</strong>
          <div style={{ color: "#555", marginTop: "2px" }}>
            {task?.employee_details?.length > 0
              ? task.employee_details.map((emp, index) => (
                  <div
                    key={emp.id}
                    style={{
                      marginBottom:
                        index !== task.employee_details.length - 1 ? "8px" : "0",
                    }}
                  >
                    <div style={{ fontWeight: "600", color: "#2c3e50" }}>
                      {emp.first_name} {emp.last_name}
                    </div>
                    {emp.actual_start && (
                      <div
                        style={{
                          fontSize: "10px",
                          display: "grid",
                          gridTemplateColumns: "80px 1fr",
                        }}
                      >
                        <span>Actual:</span>
                        <span>
                          {formatTime(emp.actual_start)} -{" "}
                          {formatTime(emp.actual_end)}
                        </span>
                        <span>Duration:</span>
                        <span>{emp.job_duration || "N/A"}</span>
                      </div>
                    )}
                  </div>
                ))
              : "No staff assigned"}
          </div>
        </div>
      </div>
    </Paper>
  );
};

export default TaskTooltip;